export enum GamePreferenceKey {
  Amount = '@casino/game-amount',
}
